import { Ad } from "@models/Ad.model";
import { AdSerializer } from "@models/serializers/adSerializer";
import { httpRequest } from "../../http";

export class CommandGetAd {
  async run(adId: number, expand?: Array<"content" | "children">) {
    let url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/ads/${adId}/`;

    if (expand && expand.length > 0) {
      const params = new URLSearchParams();
      expand.forEach((value) => params.append("expand", value));
      url += `?${params.toString()}`;
    }

    try {
      const response = await httpRequest<any>(url, { method: "GET" });
      return this.deserialize(response);
    } catch (error) {
      console.error("Error getting ad:", error);
      throw error;
    }
  }

  deserialize(data: any): Ad {
    const serializer = new AdSerializer();
    return serializer.deserialize(data);
  }
}
